import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconPanoramaView"><Path d="M3.28946 4.07096C2.17257 3.7391 1 4.55598 1 5.76081V18.2321C1 19.4409 2.17908 20.2571 3.29702 19.9206C9.23423 18.1338 14.7658 18.1338 20.703 19.9206C21.8209 20.2571 23 19.4409 23 18.2321V5.76081C23 4.55598 21.8274 3.7391 20.7105 4.07096C14.7422 5.84431 9.25785 5.84431 3.28946 4.07096Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPanoramaView;
